/* esm.sh - rxjs@7.8.2/dist/esm/internal/operators/zip */
import{zip as o}from"rxjs/dist/esm/internal/observable/zip";import{operate as p}from"rxjs/dist/esm/internal/util/lift";function a(...r){return p((i,t)=>{o(i,...r).subscribe(t)})}export{a as zip};
//# sourceMappingURL=zip.mjs.map